import { render, staticRenderFns } from "./BlockItemCard.vue?vue&type=template&id=60caca8e&scoped=true"
import script from "./BlockItemCard.vue?vue&type=script&lang=js"
export * from "./BlockItemCard.vue?vue&type=script&lang=js"
import style0 from "./BlockItemCard.vue?vue&type=style&index=0&id=60caca8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60caca8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCard,VCardTitle,VIcon,VSubheader})
